// extracted by mini-css-extract-plugin
module.exports = {"expandableCapacity":"expandableCapacity_expandableCapacity__P1PrQ"};